export default "__VITE_ASSET__roCYIJsD__"